import loadable from '@loadable/component';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "__login-support" */
      './LoginSupportMain'
    ),
);
